import { render, staticRenderFns } from "./FlexBody.vue?vue&type=template&id=6d10858c&lang=pug&"
import script from "./FlexBody.vue?vue&type=script&lang=js&"
export * from "./FlexBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports